import React, { useState, useEffect, useRef } from 'react';
import { SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { CenterRowDiv, ColList, ColListItem, Div, Text } from 'styles';
import { Img } from 'components/common/Img';
import { Icon } from 'components/common/Icon';
import * as S from './DashSliderStyle';

export function DashSlider(props) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const swiperRef = useRef(null);
  const list = [
    {
      label: 'House1',
      img: 'dashHouse',
      val1: '치커리, 상추',
      val2: '에어컨(냉난방) 1대, 환기팬 2대, LED 인공광, 소형 유동팬 12대, 제습기 1대 에어컨(냉난방) 1대, 환기팬 2대, LED 인공광, 소형 유동팬 12대, 제습기 1대',
    },
    {
      label: 'House2',
      img: 'dashHouse',
      val1: '치커리, 상추',
      val2: '에어컨(냉난방) 1대, 환기팬 2대, LED 인공광, 소형 유동팬 12대, 제습기 1대',
    },
    // {
    //   label: 'House3',
    //   img: 'dashHouse',
    //   val1: '치커리, 상추',
    //   val2: '에어컨(냉난방) 1대, 환기팬 2대, LED 인공광, 소형 유동팬 12대, 제습기 1대',
    // },
  ];

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.swiper.updateSize();
    }
  }, [currentIndex]);

  return (
    <S.SliderWrap $current={currentIndex} $length={list.length}>
      <CenterRowDiv className="prev">
        <Icon name="Arrow" $transform="rotate(90deg)" $width={24} $height={24} $pathOpacity="0.2" />
      </CenterRowDiv>
      <S.CustomSwiper
        modules={[Navigation]}
        ref={swiperRef}
        spaceBetween={16}
        slidesPerView={1}
        navigation={{
          prevEl: '.prev',
          nextEl: '.next',
        }}
        pagination={{ clickable: true }}
        onSlideChange={({ activeIndex }) => setCurrentIndex(activeIndex)}
        onInit={(swiper) => setCurrentIndex(swiper.activeIndex)}
      >
        {list.map((item, index) => (
          <SwiperSlide key={index}>
            <S.Container>
              <S.ImgWrap>
                <Img src={item.img} />
              </S.ImgWrap>
              <Div>
                <S.ChipText>
                  <Text $color="primary600" $type="l15">
                    {item.label}
                  </Text>
                </S.ChipText>
                <ColList $marginTop={16} $gap={16} $padding="0 4px">
                  <ColListItem $gap={4}>
                    <Text $type="m14" $color="supportive">
                      재배 작물
                    </Text>
                    <Text $type="m18">{item.val1}</Text>
                  </ColListItem>
                  <ColListItem $gap={4}>
                    <Text $type="m14" $color="supportive">
                      생산설비 제어 요소
                    </Text>
                    <Text $type="m18" $maxLine={2}>
                      {item.val2}
                    </Text>
                  </ColListItem>
                </ColList>
              </Div>
            </S.Container>
          </SwiperSlide>
        ))}
      </S.CustomSwiper>
      <CenterRowDiv className="next">
        <Icon name="Arrow" $transform="rotate(-90deg)" $width={24} $height={24} $pathOpacity="0.2" />
      </CenterRowDiv>
    </S.SliderWrap>
  );
}
